import type { PropsWithChildren } from "react";
import type { TranslationFn } from "../../../types";

export interface IAddressListProps {
  options: IRadioOption[];
  selectedValue: string;
  closeDrawer: (value: boolean) => void;
  onSelect: (value: string) => void;
  onUpdateUnverifiedAddress?: (addressId: string) => void;
  t: TranslationFn;
}

export interface IAddressListItemProps extends PropsWithChildren {
  selectedValue: string;
  status?: string;
  value: string;
  onSelect: (value: string) => void;
  closeDrawer?: (value: boolean) => void;
}

export interface IRadioOption {
  label: string | JSX.Element;
  status?: string;
  value: string;
}

export type TBadgeColor = "blue" | "red-400" | "main";
export type TBorderColor =
  | "border-c4red-400"
  | "border-primary"
  | "border-gray-100";

export const badgeColorMap: Record<string, TBadgeColor> = {
  default: "blue",
  other: "main",
  unverified: "red-400",
};

export const borderColorMap: Record<string, TBorderColor> = {
  unverified: "border-c4red-400",
  selected: "border-primary",
  default: "border-gray-100",
};
